//公共服务接口
import http from "@/promise/http"
const CONTROLLER_NAME = "/publicServer/"

// 通过银行卡识别所属银行
export const postIdentifyBankCard = path => {
    return http.post(CONTROLLER_NAME.concat('identifyBankCard'), path)
}

// 语音输入
export const postSpeechRecognition=base64=>{
    return http.post(CONTROLLER_NAME.concat('speechRecognition'), base64)
}